/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { defaultTheme, Provider } from "@adobe/react-spectrum";
import PreviewError from "icons/preview_error.svg";
import IconCSS from "icons/Icon.css";

const PreviewErrorIcon = () => (
    <Provider colorScheme="light" theme={ defaultTheme }>
        <div className={ IconCSS.icon }>
            <PreviewError />
        </div>
    </Provider>
);

export default PreviewErrorIcon;
